export default class ReadMore {

  constructor() {
    $('html').on('click', '.read-more-button', (event) => {
      this.onButtonClick(event);
    });
  }

  onButtonClick(event) {
    const $button = $(event.currentTarget),
          $contentWrapper = $('#' + $button.attr('aria-controls'));
    if (!$contentWrapper.length) {
      throw 'Could not find content wrapper associated with Read More';
    }

    if ($button.attr('aria-expanded') === 'false') {
      $button
        .text('Read Less')
        .attr('aria-expanded', 'true')
      ;
      $contentWrapper
        .css('opacity', 0)
        .removeAttr('hidden')
        // force browser render for opacity's sake
        .height();
      $contentWrapper.css('opacity', '');
    } else {
      $contentWrapper.attr('hidden', '');
      $button
        .text('Read More')
        .attr('aria-expanded', 'false')
      ;
    }
  }

}
